<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import minhead from "../../../../common/minHead/index.vue";
import {
    contrastResultDetailPageQuery
} from '../../../../../api/contrastSetting.js';
export default {
  name: "dbjgmx",
  components: {minhead},
  data() {
    return {
      tablekey: 0,
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      sort: "",
      order: "",
      tableData: []
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    mxShuizId: {
      type: String,
      default: "",
    },
    mxShuizName: {
      type: String,
      default: "",
    },
	  ywdiags: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
	ywdiags:function(indexVal, oldVal) {
		if(indexVal == true){
			this.contrastResultDetailPageQuery();
		}else{
			Object.keys(this.searchdata).map(key=>{
				this.searchdata[key] = ''
			})
		}
    },
  },
  created() {
  },
  mounted() {
	 
  },
  methods: {
	  selectchange(e){
		  
	  },
	  resetClickFun(){
		 this.searchlist =getdata().searchlist
	  },
    /* 新增/编辑 */
    closediag() {
      this.ywdiag = false;
    },
    /* 新增/编辑 */
    /* 表格 */
    sortchange(data) {
      this.sort = data.prop;
      this.order = data.order == "ascending" ? "asc" : "desc";
      this.contrastResultDetailPageQuery();
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.contrastResultDetailPageQuery();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.contrastResultDetailPageQuery();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.contrastResultDetailPageQuery();
    },
    contrastResultDetailPageQuery() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.resultId = this.id;
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = this.sort;
      params.order = this.order;
      contrastResultDetailPageQuery(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    /* 表格 */
    /* 搜索筛选 */
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
    },
    /* 搜索筛选 */
    //返回
    forback() {
      this.$emit("forback", false);
    },
  },
};
</script>
<style scoped lang="less">
@import url('./index.less');
</style>
